import { Caption } from '@heathmont/moon-core';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';
import media from '~/client/shared/media';

const Header = styled(Caption)`
  text-transform: none;
  color: #000;
  font-size: ${rem(20)};
  line-height: ${rem(28)};
  ${media.tabletSmall} {
    text-transform: uppercase;
    color: ${({ theme }) => theme.color.trunks[100]};
    font-size: ${rem(10)};
    line-height: ${rem(12)};
  }
`;
export default Header;
